<button mat-raised-button class="page-button" (click)="openSurveyReportDialog()">View Survey Data</button>
<button mat-raised-button class="page-button" (click)="openGopherTerminal()">Open Remote Forms Terminal</button>
<button mat-raised-button class="page-button" (click)="openPatientLookup()">Tracker Search</button>
<mat-accordion>
  @for (table of trackingTables; track table) {
    <mat-expansion-panel class="tracker-accordian">
      <mat-expansion-panel-header class="tracker-accordian-header">
        <mat-panel-title>
          {{table.name}}
        </mat-panel-title>
        <mat-panel-description>
          ({{table.dataTable.data.length}})
        </mat-panel-description>
      </mat-expansion-panel-header>
      <mat-progress-spinner style="display: inline-block;" diameter="50" mode="indeterminate"
      [style.display]="getWorkingCount($index) > 0 ? '': 'none'"></mat-progress-spinner>
      <div style="overflow-x: scroll; overflow-y: visible;">
        <app-new-patient-tracker-table [table]="table" [noShowStatusIds]="noShowStatusIds" [treatmentStatuses]="treatmentStatuses" [remoteTargets]="[]">
        </app-new-patient-tracker-table>
      </div>
    </mat-expansion-panel>
  }
</mat-accordion>

